"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticsIngestClient = exports.DocStatus = void 0;
const core_auth_1 = require("@deliverr/core-auth");
const LogisticsClient_1 = require("./LogisticsClient");
const commons_utils_1 = require("@deliverr/commons-utils");
var DocStatus;
(function (DocStatus) {
    DocStatus["SUCCESS"] = "SUCCESS";
    DocStatus["PARTIAL_ERROR"] = "PARTIAL_ERROR";
    DocStatus["ERROR"] = "ERROR";
})(DocStatus = exports.DocStatus || (exports.DocStatus = {}));
class LogisticsIngestClient {
    constructor(indexName, options) {
        this.client = new LogisticsClient_1.LogisticsClient(indexName, Object.assign(Object.assign({}, options), { baseURL: options.baseURL || (0, commons_utils_1.getEnvString)("LOGISTICS_SEARCH_INGEST_BASE_URL"), authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL }));
    }
    async create(records) {
        if (records.length === 0) {
            return Promise.resolve([
                {
                    status: DocStatus.SUCCESS,
                },
            ]);
        }
        return this.client.mutate(LogisticsClient_1.Operation.CREATE, records);
    }
    async update(records) {
        if (records.length === 0) {
            return Promise.resolve([
                {
                    status: DocStatus.SUCCESS,
                },
            ]);
        }
        return this.client.mutate(LogisticsClient_1.Operation.UPDATE, records);
    }
    async delete(records) {
        if (records.length === 0) {
            return Promise.resolve([
                {
                    status: DocStatus.SUCCESS,
                },
            ]);
        }
        return this.client.mutate(LogisticsClient_1.Operation.DELETE, records);
    }
}
exports.LogisticsIngestClient = LogisticsIngestClient;
//# sourceMappingURL=LogisticsIngestClient.js.map